import { CurrencyPipe } from "@angular/common";
import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  SimpleChanges,
  OnChanges,
} from "@angular/core";
import { Params, Router } from "@angular/router";
import * as moment from "moment";
import { formatDate } from '@angular/common';
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { HttpParams } from "@angular/common/http";
import { InvoiceService } from "./invoices.service";

@Component({
  selector: 'app-report-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss'],
  providers: [CurrencyPipe],
})
export class InvoicesComponent
  extends FeaturesBaseComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() allInvoices;
  @Input() pendingAmounts;
  @Input() invoicePayment;
  totalAmtPerMonth;
  rowData;
  columnDefs;
  private gridApi;
  rowSelection: string;
  minFromDate: Date;
  maxDate: Date;
  minToDate: Date;
  invoiceStartDate: any;
  invoiceEndDate: any;
  isRowSelected: boolean = false;
  selectedRows: any;
  gridColumnApi: any;
  searchValue: any;
  constructor(
    private router: Router,
    private invoiceService: InvoiceService,
    private currencyPipe: CurrencyPipe
  ) {
    super();
    const currentYear = new Date().getFullYear();
    this.minFromDate = new Date(currentYear - 20, 0, 1);
    this.maxDate = new Date();
  }
  ngOnInit(): void {
    const self = this;
    super.ngOnInit();
    this.rowSelection = "single";
    this.columnDefs = [
      { field: "invoiceId", headerName: "invoiceId", width: 0, hide: true },
      {
        field: "invoiceNumber",
        headerName: "Invoice #",
        width: 145,
        checkboxSelection: true,
      },
      {
        field: "invoiceDate",
        headerName: "Date",
        width: 140,
        sort: "desc",
        cellRenderer: (data) => {
          return moment(data.value).format("MM/DD/YYYY");
        },
      },
      { field: "accountNumber", headerName: "Account #", width: 170 },
      { field: "businessName", headerName: "Business Name", width: 220 },
      {
        field: "amount",
        headerName: "Amount",
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
        width: 150,
      },
      { field: "createdBy", headerName: "Generated By", width: 220 },
      { field: "paymentMethod", headerName: "Payment Method", width: 200 },
      { field: "accountType", headerName: "Account Type ", width: 200 },
      { field: "displayName", headerName: "Sales Rep/Dist", width: 220 },
      { field: "address", headerName: "Address", width: 200 },
      { field: "city", headerName: "City", width: 200 },
      { field: "state", headerName: "State", width: 200 },
      {
        field: "invoiceDate",
        headerName: "Aged Days",
        width: 172,
        pinned: "right",
        cellRenderer: function (params) {
          if (params.data.status.trim() == "Paid") {
            return '';
          }
          if (params.data.status.trim() == "Pending") {
            var today = moment();
           
            var invoicedate = moment(params.data.invoiceDate); 
           
            let days = today.diff(invoicedate, 'days');
            return days;
          }
        },
      },
      {
        field: "status",
        headerName: "Status",
        width: 280,
        pinned: "right",
        cellRenderer: function (params) {
          if (params.data.status.trim() == "Paid") {
            return '<span class="send-action cur-point text-center rounded-pill bg-success"><i class="mi mi-done small-icon"></i>Paid</span>';
          }
          if (params.data.status.trim() == "NoPay") {
            return '<span class="send-action cur-point text-center rounded-pill bg-nopay"><i class="mi mi-NotInterested small-icon"></i>No Pay</span>';
          }
          if (params.data.status.trim() == "Rejected") {
            return '<span class="send-action cur-point text-center rounded-pill bg-error"><i class="mi mi-close small-icon"></i>Rejected</span>';
          }
          if (params.data.status.trim() == "Pending") {
            if (params.data.status.trim() == "Pending" && params.data.invoiceType=='Manual') {
              return '<span class="send-action cur-point text-center rounded-pill bg-warning"><i class="mi mi-fiber-manual-record small-icon" style="font-size: 0.95rem!important;"></i>Pending</span><span class="send-action cur-point text-center rounded-pill bg-error"><i class="mi mi-delete small-icon"></i>Reject</span>';
            }
            else{
              return '<span class="send-action cur-point text-center rounded-pill bg-warning"><i class="mi mi-fiber-manual-record small-icon" style="font-size: 0.95rem!important;"></i>Pending</span>';
          }
        }
        },
        onCellClicked: function (params) {
          if (params.data.status.trim() == "Pending" && params.data.invoiceType=='Manual') {
            self.handleReject(params.data.invoiceId);
          }
        },
      },
    ];
  }
  handleReject(invoiceId) {
    this.invoiceService
      .rejectManualInvoice(invoiceId)
      .subscribe((res) => {
        if (res["httpcode"] == 200 ) {
          this.toastrService.success(`Invoice Rejected!`, `Success`);
          let currentUrl = this.router.url;
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate([currentUrl]);
        }
      });
    
  }
  //invoiceDate
  exportData() {
    let header = this.columnDefs.map((columnDef) => {
      let headerName = columnDef.headerName;
      return headerName;
    });
    let params: any = {
      fileName: "Invoice-Report.csv",
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs
        .map((c) => c.field || c.colId)
        .filter((c) => !!c),
    };
    params.customHeader = header.join(params.columnSeparator);
    params.processCellCallback = (cellParams) => {
      // 
      if(cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      }else if (cellParams && cellParams.column.colId === "invoiceDate") {
        return moment(cellParams.value).format("MM/DD/YYYY"); //apply your timestamp formatter
      } else if (cellParams && cellParams.column.colId === "amount") {
        return this.currencyPipe.transform(cellParams.value);
      } else return cellParams.value; // no formatting
    };
    this.gridApi.exportDataAsCsv(params);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes["pendingAmounts"]) {
      this.pendingAmounts = changes["pendingAmounts"].currentValue;
     
    }
    if (changes["invoicePayment"]) {
      this.totalAmtPerMonth = changes["invoicePayment"].currentValue;
     
    }
    if (changes["allInvoices"]) {
      this.allInvoices = changes["allInvoices"].currentValue;
      // 
      this.setGridData(this.allInvoices);
    }
  }

  setGridData(rowData: any) {
    this.rowData = rowData;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  updateInvoice() {
    let invoiceId = this.selectedRows[0].invoiceId;
    this.router.navigateByUrl(
      `features/reports/invoices/edit-invoice/${invoiceId}`
    );
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  onSelectionChanged($e) {
    this.selectedRows = this.gridApi.getSelectedRows();
   
    if (this.selectedRows && this.selectedRows.length === 1) {
      this.isRowSelected = true;
      return;
    }
    this.isRowSelected = false;
  }

  changeFromDate(e) {
    this.minToDate = e.value;
    this.invoiceStartDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.invoiceEndDate != null && this.invoiceEndDate != undefined) {
      this.getDateChangeResult(this.invoiceStartDate, this.invoiceEndDate);
    }
  }
  changeToDate(e) {
    this.invoiceEndDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.invoiceStartDate != null && this.invoiceStartDate != undefined) {
      this.getDateChangeResult(this.invoiceStartDate, this.invoiceEndDate);
    }
  }
  getDateChangeResult(invoiceStartDate, invoiceEndDate) {
    this.invoiceService
      .getAllInvoicesRange(invoiceStartDate, invoiceEndDate)
      .subscribe((res) => {
        if (res["httpcode"] == 200 && res["data"] != null) {
          this.setGridData(res["data"]);
        }
      });
  }
}

